const dict = {
  chooseLang: "Choisir la langue",

  // Licence
  instructions: "Instructions",
  step1: "Étape 1 : Scanner le code QR",
  locateqr: "Trouvez le code QR sur votre droite.",
  useSmartphone:
    "Utilisez l’appareil photo de votre smartphone ou une application de scan de QR Code pour le scanner. Cela vous mènera à l’étape suivante.",
  step2: "Étape 2 : Entrer les informations de la playlist",
  afterScan:
    "Après avoir scanné le code QR, vous serez invité à entrer les informations de votre playlist.",
  makeSure: "Assurez-vous de remplir tous les champs requis.",
  step3: "Étape 3 : Retourner à l'application",
  onceYou:
    "Une fois que vous avez entré les détails de votre playlist, vous pouvez retourner à l'application et poursuivre votre expérience.",
  refresh: "ACTUALISER",
  playlist: "Playlist",
  bigPlaylist: "PLAYLISTS",
  noLicence: "Vous n'avez pas de licence.",
  scanLicence: "Scannez pour acheter une licence.",
  noPlaylist: "Vous n'avez aucune playlist",
  privacyBig: "MODE PRIVÉ",
  scanToAddBig: "SCANNER POUR AJOUTER UNE PLAYLIST",
  scanToBuyBig: "SCANNER POUR ACHETER UNE LICENCE",
  orVisit: "ou visitez",
  andenterdeviceID: "et entrez cet identifiant d'appareil :",
  removePlaylist: "Supprimer la playlist",
  wantToRemove: "Voulez-vous la supprimer ?",
  cancelBig: "ANNULER",

  // Accueil
  bigLiveTv: "TV EN DIRECT",
  bigMovies: "FILMS",
  bigSeries: "SÉRIES",

  // Menu des chaînes
  noChannels: "Cette playlist ne contient aucune donnée de chaîne",
  searchChannels: "Rechercher une chaîne",
  tapToPlay: "Touchez pour lire le flux vidéo.",
  categoryEmpty: "Cette catégorie est vide",

  // Films
  noMovies: "Cette playlist ne contient aucune donnée de film",
  searchMovies: "Rechercher des films",

  // Séries
  noSeries: "Cette playlist ne contient aucune donnée de série",
  searchSeries: "Rechercher des séries",

  // Entité
  play: "LECTURE",
  recommendations: "Recommandations",

  // Informations utilisateur
  userInfo: "Informations utilisateur",
  aboutApp: "À propos de l'application",

  // Compte utilisateur
  account: "Compte",
  subscriptions: "Abonnements",
  privacyPilicy: "Confidentialité & Politique",
  languge: "Langue",
  english: "Anglais",
  italian: "Italien",
  german: "Allemand",
  spanish: "Espagnol",
  french: "Français",
  greek: "Grec",

  // Derniers détails
  playInfo: "Informations de la playlist",
  playName: "Nom de la playlist :",
  host: "Hôte :",
  username: "Nom d'utilisateur :",
  password: "Mot de passe :",
  packName: "Nom du forfait :",
  expireDate: "Date d'expiration :",

  // Politique de confidentialité
  one: "1. Avertissement sur le contenu : Applay est une plateforme conçue pour améliorer votre expérience numérique. Cependant, il est important de noter Applay n'héberge, ne fournit ni ne distribue de contenu vidéo. Notre service est conçu pour accompagner votre parcours numérique, mais nous ne sommes pas responsables de la disponibilité, de la qualité ou du contenu des vidéos, car cela dépasse le cadre de nos services.",
  two: "2. Aucune responsabilité pour le contenu tiers : Applay LLC n'est pas responsable du contenu tiers auquel vous accédez via notre application. Votre interaction avec tout contenu externe, y compris sa légalité, sa fiabilité ou sa pertinence, se fait entièrement à vos risques et périls.",
  three:
    "3. Juridiction et conformité : Applay LLC opère sous la juridiction des États-Unis. Il est de la responsabilité des utilisateurs de s’assurer que l’utilisation de l’application est conforme aux lois locales, nationales et fédérales.",
  four: "4. Politique de prix : Les prix des services Applay peuvent être modifiés à tout moment sans préavis. En acceptant cet accord, vous reconnaissez et acceptez que les prix puissent varier et que ces modifications n'affecteront pas votre service actuel jusqu'au renouvellement de votre abonnement.",
  five: `5. Absence de garantie : L'application Applay et ses services sont fournis "tels quels" sans aucune garantie expresse ou implicite, y compris, mais sans s'y limiter, les garanties implicites de qualité marchande, d'adéquation à un usage particulier et de non-contrefaçon.`,
  six: "6. Acceptation des conditions : En cliquant sur Accepter, vous acceptez d’être lié par les termes de cet avertissement et reconnaissez que toute violation peut entraîner la résiliation de votre accès aux services Applay.",
  orbixUserAgreement: "CONTRAT D’UTILISATEUR Applay ET AVERTISSEMENT",
  beforeyouProcc:
    "Avant de continuer, veuillez lire et accepter les conditions suivantes :",

  // Politique de confidentialité Evomedia
  evomediaTitle: "Politique de confidentialité d'Evo TV",
  evomediaSubtitle:
    "Veuillez lire les informations suivantes sur la manière dont vos données sont traitées :",
  evomediaSection1Title: "1. Traitement et collecte des données techniques",
  evomediaSection1Body1:
    "L'application evo tv est conçue exclusivement comme un outil technique pour les clients éligibles d'Evomedia. L'application ne propose pas de formulaires d'inscription manuelle, de création de compte dans l'application, ni ne collecte de données personnelles directes (telles que votre nom, numéro de téléphone ou adresse e-mail).",
  evomediaSection1Body2:
    "Cependant, pour permettre la diffusion de contenus multimédias et garantir la sécurité du service, le système traite la catégorie de données suivante :",
  evomediaSection1Body3:
    "Identifiants de l'appareil : L'adresse MAC de l'appareil ou un identifiant client interne est transmis de manière sécurisée (via SSL/HTTPS) à nos serveurs dans le seul but de valider, authentifier et autoriser l'accès aux flux de streaming multimédia liés à votre abonnement.",
  evomediaSection1Body4:
    "Base légale et finalité : Le traitement de ces identifiants est strictement nécessaire à l'exécution d'un contrat (la fourniture du service de streaming demandé) ainsi qu'à la sécurité et à la prévention de la fraude (garantir que seuls les appareils autorisés accèdent aux flux protégés). Ces données techniques ne sont jamais utilisées à des fins marketing, ne sont jamais partagées avec des tiers et ne servent pas à suivre votre historique de navigation général.",
  evomediaSection2Title: "2. Droits des utilisateurs (RGPD)",
  evomediaSection2Body1:
    "Conformément au Règlement Général sur la Protection des Données (RGPD), étant donné que les identifiants techniques sont liés à votre compte client, vous conservez le droit d'accéder, de rectifier, de restreindre ou de demander la suppression des données associées à votre appareil. Pour exercer ces droits, veuillez nous contacter à suporte@evomedia.pt.",
  evomediaSection3Title: "3. Confidentialité des enfants",
  evomediaSection3Body1:
    "Nous ne commercialisons pas directement nos services auprès des enfants et ne collectons pas sciemment de données auprès de mineurs de moins de 13 ans. L'accès à l'application est géré et autorisé par le titulaire du compte (le client adulte).",
  evomediaSection4Title: "4. Modifications de cette politique",
  evomediaSection4Body1:
    "Nous pouvons mettre à jour notre politique de confidentialité de temps à autre afin de refléter des améliorations techniques ou des changements réglementaires. Toute mise à jour prendra effet immédiatement dès sa publication sur cette page.",
  evomediaSection5Title: "5. Nous contacter",
  evomediaSection5Body1:
    "Si vous avez des questions concernant votre confidentialité ou la gestion technique de l'application, veuillez nous contacter via :",
  evomediaSection5Body2: "E-mail du support officiel : suporte@evomedia.pt",
  evomediaSection5Body3:
    "E-mail du compte développeur : evomediamobile@gmail.com",

  //additional
  exitApp: "Quitter Applay",
  wantToExit: "Êtes-vous sûr de vouloir quitter Applay ?",
  Resume: "Reprendre",

  whatsnewinv: "Quoi de neuf dans la v",
  whatsnew: "Quoi de neuf",
  instanthomescreen: "Navigation Améliorée du Menu des Chaînes",
  instanthomescreendesc:
    "Flux de navigation amélioré et meilleure expérience utilisateur dans la sélection des chaînes.",
  turbomoviesearch: "Informations Complètes des Paramètres",
  turbomoviesearchdesc:
    "Paramètres plus détaillés et options de configuration rassemblés en un seul endroit.",
  lighterondataandbattery: "Fonction de Reprise Intelligente",
  lighterondataandbatterydesc:
    "Sauvegarde et restaure automatiquement votre position de lecture en toute fluidité.",
  underthehoodfixes: "Corrections Internes",
  underthehoodfixesdesc:
    "Stabilité améliorée du lecteur et fiabilité des opérations de recherche.",
};

export default dict;
